import { skinVars } from '@telefonica/mistica';
import { Text1 } from '@telefonica/mistica';
import React from 'react';
import './index.scss';

export interface DetailsConsumptionHeaderTabData {
    icon: any;
    text: string;
    isActive: boolean;
    setView: Function;
    setActive: string;
}
export const DetailsConsumptionHeaderTab: React.FC<DetailsConsumptionHeaderTabData> = ({
    icon,
    text,
    isActive,
    setView,
    setActive,
}: DetailsConsumptionHeaderTabData) => {
    const backgroundTab = isActive
        ? skinVars.colors.buttonPrimaryBackgroundInverse
        : skinVars.colors.buttonLinkBackgroundSelected;
    const colorText = isActive ? skinVars.colors.textLink : skinVars.colors.textPrimary;
    return (
        <div
            className='Details-consumption-header__tab'
            style={{ background: backgroundTab }}
            onClick={() => {
                setView(setActive);
            }}
        >
            <div className='Details-consumption-header__tab__content'>
                <div className='Details-consumption-headertab__content__icon'>{icon}</div>
                <div className='Details-consumption-header__tab__content__text'>
                    <Text1 medium color={colorText}>
                        {text}
                    </Text1>
                </div>
            </div>
        </div>
    );
};

export default DetailsConsumptionHeaderTab;
